var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1604",
    "data-name": "Grupo 1604",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.257,
    height: 36.257,
    viewBox: "0 0 36.257 36.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7258",
    "data-name": "Trazado 7258",
    d: "M41.717,698.411a18.129,18.129,0,1,1-18.129-18.128,18.129,18.129,0,0,1,18.129,18.128",
    transform: "translate(-5.46 -680.283)",
    fill: "#da0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7259",
    "data-name": "Trazado 7259",
    d: "M51.626,718.925a3.026,3.026,0,0,0-2.137-2.137c-1.885-.505-9.444-.505-9.444-.505s-7.559,0-9.444.505a3.026,3.026,0,0,0-2.137,2.137,33.752,33.752,0,0,0,0,11.636A3.027,3.027,0,0,0,30.6,732.7c1.885.505,9.444.505,9.444.505s7.559,0,9.444-.505a3.027,3.027,0,0,0,2.137-2.137,33.752,33.752,0,0,0,0-11.636m-14,9.443v-7.251l6.28,3.626Z",
    transform: "translate(-21.917 -706.615)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeColor);
export default __webpack_public_path__ + "static/media/youtube_color.5e6631428af0e2099cd5e3bc2bb430c2.svg";
export { ForwardRef as ReactComponent };